define("shared/components/shared/ui/flash-message", ["exports", "@ember/component", "@ember/object", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _object, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div class="alert o--alert o--alert--{{@flash.type}} {{@flash.qaCustomClassName}}" ...attributes>
    {{! Icon }}
    <span class="o--alert__icon"><i class={{this.iconClass}}></i></span>
  
    {{! Close Button }}
    <Shared::Ui::Button
      @onClick={{@close}}
      @size="none"
      @variant="none"
      aria-hidden="true"
      class="o--alert__dismiss"
      data-dismiss="alert"
    >
      {{svg-jar "close" class="o--icon--sm qa--alert_closeIcon"}}
    </Shared::Ui::Button>
  
    {{! Title }}
    {{#if @flash.title}}
      <h4 class="o--alert__title">{{@flash.title}}</h4>
    {{/if}}
  
    {{! Message }}
    <p class="o--alert__text">
      {{html-safe @flash.message}}
      {{! Link }}
      {{#if @flash.link}}
        <a class="u--inline u--p__l__xs" href={{@flash.link}} target={{if @flash.linkNewTab "_blank"}}>
          {{if @flash.linkText @flash.linkText (t "shared_phrases.learn_more")}}
        </a>
      {{/if}}
    </p>
  
    {{! Action }}
    {{#if @flash.action}}
      <Shared::Ui::Button
        @onClick={{fn @flash.action @flash}}
        @size="none"
        @text={{if @flash.actionText @flash.actionText (t "shared_words.continue")}}
        @variant="none"
        class="o--alert__btn"
        data-dismiss="alert"
      />
    {{/if}}
  
    {{#if @flash.isUpgrade}}
      <Shared::Button::Upgrade
        @feature={{@flash.feature}}
        @location={{@flash.location}}
        @text={{if @flash.upgradeText @flash.upgradeText "Upgrade"}}
        as |upgradeAction text|
      >
        <Shared::Ui::Button
          @onClick={{fn this.upgrade upgradeAction}}
          @size="none"
          @text={{text}}
          @variant="none"
          class="o--alert__btn {{@flash.upgradeQaClassName}}"
          data-dismiss="alert"
        />
      </Shared::Button::Upgrade>
    {{/if}}
  
  </div>
  */
  {
    "id": "mWilqGLW",
    "block": "[[[11,0],[16,0,[29,[\"alert o--alert o--alert--\",[30,1,[\"type\"]],\" \",[30,1,[\"qaCustomClassName\"]]]]],[17,2],[12],[1,\"\\n\"],[1,\"  \"],[10,1],[14,0,\"o--alert__icon\"],[12],[10,\"i\"],[15,0,[30,0,[\"iconClass\"]]],[12],[13],[13],[1,\"\\n\\n\"],[1,\"  \"],[8,[39,0],[[24,\"aria-hidden\",\"true\"],[24,0,\"o--alert__dismiss\"],[24,\"data-dismiss\",\"alert\"]],[[\"@onClick\",\"@size\",\"@variant\"],[[30,3],\"none\",\"none\"]],[[\"default\"],[[[[1,\"\\n    \"],[1,[28,[35,1],[\"close\"],[[\"class\"],[\"o--icon--sm qa--alert_closeIcon\"]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\\n\"],[41,[30,1,[\"title\"]],[[[1,\"    \"],[10,\"h4\"],[14,0,\"o--alert__title\"],[12],[1,[30,1,[\"title\"]]],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[1,\"  \"],[10,2],[14,0,\"o--alert__text\"],[12],[1,\"\\n    \"],[1,[28,[35,3],[[30,1,[\"message\"]]],null]],[1,\"\\n\"],[41,[30,1,[\"link\"]],[[[1,\"      \"],[10,3],[14,0,\"u--inline u--p__l__xs\"],[15,6,[30,1,[\"link\"]]],[15,\"target\",[52,[30,1,[\"linkNewTab\"]],\"_blank\"]],[12],[1,\"\\n        \"],[1,[52,[30,1,[\"linkText\"]],[30,1,[\"linkText\"]],[28,[37,4],[\"shared_phrases.learn_more\"],null]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\\n\"],[41,[30,1,[\"action\"]],[[[1,\"    \"],[8,[39,0],[[24,0,\"o--alert__btn\"],[24,\"data-dismiss\",\"alert\"]],[[\"@onClick\",\"@size\",\"@text\",\"@variant\"],[[28,[37,5],[[30,1,[\"action\"]],[30,1]],null],\"none\",[52,[30,1,[\"actionText\"]],[30,1,[\"actionText\"]],[28,[37,4],[\"shared_words.continue\"],null]],\"none\"]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,1,[\"isUpgrade\"]],[[[1,\"    \"],[8,[39,6],null,[[\"@feature\",\"@location\",\"@text\"],[[30,1,[\"feature\"]],[30,1,[\"location\"]],[52,[30,1,[\"upgradeText\"]],[30,1,[\"upgradeText\"]],\"Upgrade\"]]],[[\"default\"],[[[[1,\"\\n      \"],[8,[39,0],[[16,0,[29,[\"o--alert__btn \",[30,1,[\"upgradeQaClassName\"]]]]],[24,\"data-dismiss\",\"alert\"]],[[\"@onClick\",\"@size\",\"@text\",\"@variant\"],[[28,[37,5],[[30,0,[\"upgrade\"]],[30,4]],null],\"none\",[30,5],\"none\"]],null],[1,\"\\n    \"]],[4,5]]]]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[13]],[\"@flash\",\"&attrs\",\"@close\",\"upgradeAction\",\"text\"],false,[\"shared/ui/button\",\"svg-jar\",\"if\",\"html-safe\",\"t\",\"fn\",\"shared/button/upgrade\"]]",
    "moduleName": "shared/components/shared/ui/flash-message.hbs",
    "isStrictMode": false
  });
  let FlashMessageComponent = _exports.default = (_class = class FlashMessageComponent extends _component2.default {
    get iconClass() {
      switch (this.args.flash.type) {
        case 'success':
          return 'i-verified';
        case 'warning':
          return 'i-warning';
        case 'alert':
          return 'i-danger-1';
        case 'danger':
          return 'i-danger-1';
        case 'info':
          return 'i-info';
        default:
          return '';
      }
    }
    upgrade(upgradeFn, event) {
      upgradeFn(event);
      this.args.close();
    }
  }, (_applyDecoratedDescriptor(_class.prototype, "upgrade", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "upgrade"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, FlashMessageComponent);
});